import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import colors from 'common/styles/colors';

import { utcDateFormatter } from 'common/services/date';

import styles from './index.module.css';

/**
 * Can't change this component to function while Griddle doesn't support it
 * @extends PureComponent
 */
class Timestamp extends PureComponent {
  render() {
    const { value, textColor } = this.props;
    const displayUtcDate = utcDateFormatter(value);
    const dateTime = displayUtcDate('yyyy-MM-ddTHH:mm:ss');
    const hoursMinutes = displayUtcDate('HH:mm');
    const dayAndMonth = displayUtcDate('dd MMM yyyy');

    return (
      <time
        className={styles.date}
        style={{
          color: colors[textColor || 'rebranding-md-color-brand-black'],
        }}
        dateTime={dateTime}
      >
        <span>{dayAndMonth}</span>- <span>{hoursMinutes}</span>
      </time>
    );
  }
}

Timestamp.propTypes = {
  value: PropTypes.string.isRequired,
  textColor: PropTypes.oneOf(Object.keys(colors)),
};

export default Timestamp;
